import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageSeo, { BASE } from "@/components/feature/PageSeo";
import { faqs, events } from "@/mocks/events";
import Hero from "./components/Hero";
import StoryFeed from "./components/StoryFeed";
import PeopleShowcase from "./components/PeopleShowcase";
import RulesBand from "./components/RulesBand";
import Subscribe from "./components/Subscribe";
import Faq from "./components/Faq";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "吃瓜爆网",
  url: BASE + "/",
  logo: BASE + "/logo.png",
  sameAs: [],
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const itemListJsonLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "最近走红事件",
  itemListElement: events.slice(0, 5).map((e, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: e.title,
    url: `${BASE}/shijian/${e.id}`,
  })),
};

export default function Home() {
  return (
    <>
      <PageSeo
        title="吃瓜爆网｜新晋网红与爆红人物走红事件追踪"
        description="吃瓜爆网持续追踪新晋网红与爆红人物的走红事件与热门主角，从素人到顶流的出圈之路全记录，带你读懂每一次走红背后的真实故事。"
        keywords="吃瓜爆网,新晋网红,爆红人物,热门主角,走红事件,出圈盘点"
        path="/"
        jsonLd={[orgJsonLd, faqJsonLd, itemListJsonLd]}
      />
      <div className="min-h-screen bg-background-50">
        <Header />
        <main>
          <Hero />
          <StoryFeed />
          <PeopleShowcase />
          <RulesBand />
          <Subscribe />
          <Faq />
        </main>
        <Footer />
      </div>
    </>
  );
}